import React, {Fragment} from 'react';
import {Stack, Typography} from '@mui/material';

import {FinishWithoutCompleteFlowEnum} from 'main/analytics/gaTagsEnum';
import {AlertActions, AlertModal} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import {useTelehealthDuplicityDialog} from './hooks/useTelehealthDuplicityDialog';
import {TelehealthDuplicityDialogProps} from './types';
import {TelehealthDuplicityBookedCard} from '../TelehealthDuplicityBookedCard';

const {goBack} = translations['pt-br'].commons;

export function TelehealthDuplicityDialog({
	open,
	setOpen,
	scheduledBooking,
}: TelehealthDuplicityDialogProps) {
	const {
		handleSwapSpecialty,
		colors,
		isMobile,
		handeClose,
		alertModalPaperProps,
		contentTitle,
		contentDescription,
	} = useTelehealthDuplicityDialog({scheduledBooking, setOpen});

	return (
		<AlertModal
			data-tag-id={FinishWithoutCompleteFlowEnum.POSSUI_CONSULTA_EXISTENTE_ESPECIALIDADE}
			showIcon={false}
			description={isMobile ? undefined : contentDescription}
			headerTitle={contentTitle}
			onClose={handeClose}
			open={open}
			variant="warning"
			fullScreen={isMobile}
			slotProps={{
				paper: {
					style: alertModalPaperProps,
				},
			}}
			footerProps={{
				sx: {
					p: 0,
				},
			}}
			customContentStyles={{
				sx: {
					p: isMobile ? 0 : 3,
				},
			}}
			subDescription={
				<Fragment>
					{isMobile ? (
						<Stack sx={{bgcolor: colors.brand.primary.blue}} p={3}>
							<Typography variant="h6" color={colors.brand.primary.white}>
								{contentDescription}
							</Typography>
						</Stack>
					) : null}
					<Stack px={isMobile ? 3 : 0} width={'100%'}>
						<TelehealthDuplicityBookedCard scheduledBooking={scheduledBooking} />
					</Stack>
				</Fragment>
			}
			footerContent={
				<AlertActions
					primaryAction={handleSwapSpecialty}
					secondaryAction={handeClose}
					secondaryText={goBack}
					primaryText={contentTitle}
					flexDirection={'column-reverse'}
					secondaryBtnVariant="outlined"
					customStackProps={{bgcolor: colors.brand.primary.white, p: '8px 16px'}}
				/>
			}
		/>
	);
}
